import apiClient from "@/api/client";
import type { SupplyItem } from "../types";

export const suppliesApi = {
  list: (params?: Record<string, string>) =>
    apiClient
      .get<{ data: SupplyItem[] }>("/supply-items/", { params })
      .then((r) => r.data.data),

  get: (id: string) =>
    apiClient
      .get<{ data: SupplyItem }>(`/supply-items/${id}/`)
      .then((r) => r.data.data),

  create: (data: {
    item_name: string;
    product_link?: string;
    quantity: string;
    unit?: string;
    priority?: string;
    delivery_location?: string;
    preferred_delivery?: string;
    notes?: string;
    requested_at?: string;
  }) =>
    apiClient
      .post<{ data: SupplyItem }>("/supply-items/", data)
      .then((r) => r.data.data),

  update: (id: string, data: Partial<SupplyItem>) =>
    apiClient
      .patch<{ data: SupplyItem }>(`/supply-items/${id}/`, data)
      .then((r) => r.data.data),

  delete: (id: string) => apiClient.delete(`/supply-items/${id}/`),

  approve: (id: string) =>
    apiClient
      .post<{ data: SupplyItem }>(`/supply-items/${id}/approve/`, {})
      .then((r) => r.data.data),

  order: (id: string, data?: { ordered_at?: string; delivery_info?: string; notes?: string }) =>
    apiClient
      .post<{ data: SupplyItem }>(`/supply-items/${id}/order/`, data ?? {})
      .then((r) => r.data.data),

  reject: (id: string, data?: { notes?: string }) =>
    apiClient
      .post<{ data: SupplyItem }>(`/supply-items/${id}/reject/`, data ?? {})
      .then((r) => r.data.data),

  markDelivered: (id: string, data?: { delivered_at?: string }) =>
    apiClient
      .post<{ data: SupplyItem }>(`/supply-items/${id}/mark_delivered/`, data ?? {})
      .then((r) => r.data.data),

  reopen: (id: string) =>
    apiClient
      .post<{ data: SupplyItem }>(`/supply-items/${id}/reopen/`, {})
      .then((r) => r.data.data),
};
